import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KPIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KP" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path fill="#C51918" stroke="#F7FCFF" d="M16.5 2.5v7h-17v-7h17Z" />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M5 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
          clipRule="evenodd"
        />
        <Path
          fill="#C51918"
          fillRule="evenodd"
          d="M4.997 6.935 3.64 7.88l.48-1.584-1.32-1 1.655-.033.543-1.563.544 1.563 1.654.034-1.318 1 .479 1.583-1.359-.945Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
